import { lazy } from 'react';
import { StrategyBuilder, StrategyRules } from '@tools/ui/dime';
import type { AppRouter } from '@tools/ui/types';

export const STRATEGY_BUILDER_BASE_PATH = '/feature-strategy-builder';

const StrategiesView = lazy(
  () =>
    import(
      /* webpackChunkName: "FeatureStrategyBuilderRoutes" */ '../pages/StrategiesView'
    )
);

const StrategyView = lazy(
  () =>
    import(
      /* webpackChunkName: "FeatureStrategyBuilderRoutes" */ '../pages/StrategyView'
    )
);

const StrategyRuleView = lazy(
  () =>
    import(
      /* webpackChunkName: "FeatureStrategyBuilderRoutes" */ '../pages/StrategyRuleView'
    )
);

const StrategyRulesView = lazy(
  () =>
    import(
      /* webpackChunkName: "FeatureStrategyBuilderRoutes" */ '../pages/StrategyRulesView'
    )
);

const StrategyCompareView = lazy(
  () =>
    import(
      /* webpackChunkName: "FeatureStrategyBuilderRoutes" */ '../pages/StrategyCompareView'
    )
);

export const featureStrategyBuilderRoutes: AppRouter = {
  modules: [
    {
      redirectFrom: [
        STRATEGY_BUILDER_BASE_PATH,
        `${STRATEGY_BUILDER_BASE_PATH}/*`
      ]
    },
    {
      name: 'List all Risk Strategies',
      path: `${STRATEGY_BUILDER_BASE_PATH}/strategies`,
      component: StrategiesView,
      exact: false,
      icon: StrategyBuilder,
      pages: []
    },
    {
      name: 'View Strategy Details',
      path: `${STRATEGY_BUILDER_BASE_PATH}/strategy-review-screen/:strategyId`,
      component: StrategyView,
      hideFromMenu: true,
      exact: true,
      pages: []
    },
    {
      name: 'Compare Strategy',
      path: `${STRATEGY_BUILDER_BASE_PATH}/compare/:strategyName/:strategyId`,
      component: StrategyCompareView,
      hideFromMenu: true,
      exact: true,
      pages: []
    },
    {
      name: 'List all strategy rules',
      path: `${STRATEGY_BUILDER_BASE_PATH}/strategy-rules`,
      component: StrategyRulesView,
      icon: StrategyRules,
      exact: true,
      pages: []
    },
    {
      name: 'Create or Update Strategy Rule',
      path: `${STRATEGY_BUILDER_BASE_PATH}/strategy-rules/:ruleId`,
      component: StrategyRuleView,
      hideFromMenu: true,
      exact: true,
      pages: []
    }
  ]
};
